export default class Sticky {
  get CLASSES() {
    return {
      isSticky: 'is-sticky',
    }
  }

  constructor() {
    this.target = document.querySelector('[data-sticky]');
    if (!this.target) return;
    this.hero = document.querySelector('[data-hero]');
    this.more = document.querySelector('[data-more-buttons]');
    this.height = this.hero.clientHeight
    this.init();
  }

  init() {
    this.onScroll();
  }

  onScroll() {
    ScrollTrigger.create({
      trigger: this.main,
      start: `top -${this.height}px`,
      onEnter: () => this.addClass(),
      onLeaveBack: () => this.removeClass(),
    });
    ScrollTrigger.create({
      trigger: this.more,
      start: 'top bottom',
      onEnter: () => this.removeClass(),
      onLeaveBack: () => this.addClass(),
    });
  }

  addClass() {
    if (!this.target.classList.contains(this.CLASSES.isSticky)) {
      this.target.classList.add(this.CLASSES.isSticky);
    }
  }

  removeClass() {
    if (this.target.classList.contains(this.CLASSES.isSticky)) {
      this.target.classList.remove(this.CLASSES.isSticky);
    }
  }
}
